"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReasonsForTestingDtoToJSON = exports.ReasonsForTestingDtoFromJSONTyped = exports.ReasonsForTestingDtoFromJSON = exports.instanceOfReasonsForTestingDto = void 0;
var runtime_1 = require("../runtime");
var CarrierReasonForTestingWriteDto_1 = require("./CarrierReasonForTestingWriteDto");
var CombiCddReasonForTestingDto_1 = require("./CombiCddReasonForTestingDto");
var CombiPdReasonForTestingDto_1 = require("./CombiPdReasonForTestingDto");
var CombiPfuReasonForTestingDto_1 = require("./CombiPfuReasonForTestingDto");
var CombiPocReasonForTestingDto_1 = require("./CombiPocReasonForTestingDto");
var CombiRplReasonForTestingDto_1 = require("./CombiRplReasonForTestingDto");
var FVTDetailsDto_1 = require("./FVTDetailsDto");
var NipsReasonForTestingDto_1 = require("./NipsReasonForTestingDto");
var PGxReasonForTestingDto_1 = require("./PGxReasonForTestingDto");
var ReasonsForTestingDtoFamilyHistoryStructured_1 = require("./ReasonsForTestingDtoFamilyHistoryStructured");
var ReasonsForTestingDtoIndicationStructured_1 = require("./ReasonsForTestingDtoIndicationStructured");
var TumorProfilingReasonForTestingDto_1 = require("./TumorProfilingReasonForTestingDto");
/**
 * Check if a given object implements the ReasonsForTestingDto interface.
 */
function instanceOfReasonsForTestingDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfReasonsForTestingDto = instanceOfReasonsForTestingDto;
function ReasonsForTestingDtoFromJSON(json) {
    return ReasonsForTestingDtoFromJSONTyped(json, false);
}
exports.ReasonsForTestingDtoFromJSON = ReasonsForTestingDtoFromJSON;
function ReasonsForTestingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fvtOrderDetails': !(0, runtime_1.exists)(json, 'fvtOrderDetails') ? undefined : (0, FVTDetailsDto_1.FVTDetailsDtoFromJSON)(json['fvtOrderDetails']),
        'carrierReasonForTesting': !(0, runtime_1.exists)(json, 'carrierReasonForTesting') ? undefined : (0, CarrierReasonForTestingWriteDto_1.CarrierReasonForTestingWriteDtoFromJSON)(json['carrierReasonForTesting']),
        'combiCddReasonForTesting': !(0, runtime_1.exists)(json, 'combiCddReasonForTesting') ? undefined : (0, CombiCddReasonForTestingDto_1.CombiCddReasonForTestingDtoFromJSON)(json['combiCddReasonForTesting']),
        'combiPocReasonForTesting': !(0, runtime_1.exists)(json, 'combiPocReasonForTesting') ? undefined : (0, CombiPocReasonForTestingDto_1.CombiPocReasonForTestingDtoFromJSON)(json['combiPocReasonForTesting']),
        'combiRplReasonForTesting': !(0, runtime_1.exists)(json, 'combiRplReasonForTesting') ? undefined : (0, CombiRplReasonForTestingDto_1.CombiRplReasonForTestingDtoFromJSON)(json['combiRplReasonForTesting']),
        'combiPdReasonForTesting': !(0, runtime_1.exists)(json, 'combiPdReasonForTesting') ? undefined : (0, CombiPdReasonForTestingDto_1.CombiPdReasonForTestingDtoFromJSON)(json['combiPdReasonForTesting']),
        'combiPfuReasonForTesting': !(0, runtime_1.exists)(json, 'combiPfuReasonForTesting') ? undefined : (0, CombiPfuReasonForTestingDto_1.CombiPfuReasonForTestingDtoFromJSON)(json['combiPfuReasonForTesting']),
        'nipsReasonForTesting': !(0, runtime_1.exists)(json, 'nipsReasonForTesting') ? undefined : (0, NipsReasonForTestingDto_1.NipsReasonForTestingDtoFromJSON)(json['nipsReasonForTesting']),
        'pgxReasonForTesting': !(0, runtime_1.exists)(json, 'pgxReasonForTesting') ? undefined : (0, PGxReasonForTestingDto_1.PGxReasonForTestingDtoFromJSON)(json['pgxReasonForTesting']),
        'tumorProfilingReasonForTesting': !(0, runtime_1.exists)(json, 'tumorProfilingReasonForTesting') ? undefined : (0, TumorProfilingReasonForTestingDto_1.TumorProfilingReasonForTestingDtoFromJSON)(json['tumorProfilingReasonForTesting']),
        'positiveFamilyHistory': !(0, runtime_1.exists)(json, 'positiveFamilyHistory') ? undefined : json['positiveFamilyHistory'],
        'individualAffected': !(0, runtime_1.exists)(json, 'individualAffected') ? undefined : json['individualAffected'],
        'isTyrerCuzickOrdered': !(0, runtime_1.exists)(json, 'isTyrerCuzickOrdered') ? undefined : json['isTyrerCuzickOrdered'],
        'otherIndicationReason': !(0, runtime_1.exists)(json, 'otherIndicationReason') ? undefined : json['otherIndicationReason'],
        'familyHistory': !(0, runtime_1.exists)(json, 'familyHistory') ? undefined : json['familyHistory'],
        'indication': !(0, runtime_1.exists)(json, 'indication') ? undefined : json['indication'],
        'primaryIndication': !(0, runtime_1.exists)(json, 'primaryIndication') ? undefined : json['primaryIndication'],
        'previousResults': !(0, runtime_1.exists)(json, 'previousResults') ? undefined : json['previousResults'],
        'lomn': !(0, runtime_1.exists)(json, 'lomn') ? undefined : json['lomn'],
        'familyHistoryStructured': !(0, runtime_1.exists)(json, 'familyHistoryStructured') ? undefined : (0, ReasonsForTestingDtoFamilyHistoryStructured_1.ReasonsForTestingDtoFamilyHistoryStructuredFromJSON)(json['familyHistoryStructured']),
        'indicationStructured': !(0, runtime_1.exists)(json, 'indicationStructured') ? undefined : (0, ReasonsForTestingDtoIndicationStructured_1.ReasonsForTestingDtoIndicationStructuredFromJSON)(json['indicationStructured']),
    };
}
exports.ReasonsForTestingDtoFromJSONTyped = ReasonsForTestingDtoFromJSONTyped;
function ReasonsForTestingDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fvtOrderDetails': (0, FVTDetailsDto_1.FVTDetailsDtoToJSON)(value.fvtOrderDetails),
        'carrierReasonForTesting': (0, CarrierReasonForTestingWriteDto_1.CarrierReasonForTestingWriteDtoToJSON)(value.carrierReasonForTesting),
        'combiCddReasonForTesting': (0, CombiCddReasonForTestingDto_1.CombiCddReasonForTestingDtoToJSON)(value.combiCddReasonForTesting),
        'combiPocReasonForTesting': (0, CombiPocReasonForTestingDto_1.CombiPocReasonForTestingDtoToJSON)(value.combiPocReasonForTesting),
        'combiRplReasonForTesting': (0, CombiRplReasonForTestingDto_1.CombiRplReasonForTestingDtoToJSON)(value.combiRplReasonForTesting),
        'combiPdReasonForTesting': (0, CombiPdReasonForTestingDto_1.CombiPdReasonForTestingDtoToJSON)(value.combiPdReasonForTesting),
        'combiPfuReasonForTesting': (0, CombiPfuReasonForTestingDto_1.CombiPfuReasonForTestingDtoToJSON)(value.combiPfuReasonForTesting),
        'nipsReasonForTesting': (0, NipsReasonForTestingDto_1.NipsReasonForTestingDtoToJSON)(value.nipsReasonForTesting),
        'pgxReasonForTesting': (0, PGxReasonForTestingDto_1.PGxReasonForTestingDtoToJSON)(value.pgxReasonForTesting),
        'tumorProfilingReasonForTesting': (0, TumorProfilingReasonForTestingDto_1.TumorProfilingReasonForTestingDtoToJSON)(value.tumorProfilingReasonForTesting),
        'positiveFamilyHistory': value.positiveFamilyHistory,
        'individualAffected': value.individualAffected,
        'isTyrerCuzickOrdered': value.isTyrerCuzickOrdered,
        'otherIndicationReason': value.otherIndicationReason,
        'familyHistory': value.familyHistory,
        'indication': value.indication,
        'primaryIndication': value.primaryIndication,
        'previousResults': value.previousResults,
        'lomn': value.lomn,
        'familyHistoryStructured': (0, ReasonsForTestingDtoFamilyHistoryStructured_1.ReasonsForTestingDtoFamilyHistoryStructuredToJSON)(value.familyHistoryStructured),
        'indicationStructured': (0, ReasonsForTestingDtoIndicationStructured_1.ReasonsForTestingDtoIndicationStructuredToJSON)(value.indicationStructured),
    };
}
exports.ReasonsForTestingDtoToJSON = ReasonsForTestingDtoToJSON;
